import { ResourceOptions } from 'react-admin';
import { FaHistory } from 'react-icons/fa';
import './dataProvider';
import { Resources } from '../resource';

export { default as list } from './List';

export const name = Resources.predictionTrading;
export const icon = FaHistory;
export const options: ResourceOptions = {
  label: 'resource.predictionTrading',
};
